import React, { useState } from "react";

import { DishItem } from "./OrderBodyDishItem";

import { convertDate } from "../../../utils/sort";

import "./archieveOrder.css";

// Archieve order

const ArchieveOrder = ({ order, isCancelledHidden, handleDeleteOneOrder }) => {
  const [isOrderBodyShown, setOrderBodyShown] = useState(false);
  const [isDeleteDivShown, setDeleteDivShown] = useState(false);

  const toggleDropDown = () => {
    if (!isOrderBodyShown) setOrderBodyShown(true);
    if (isOrderBodyShown) setOrderBodyShown(false);
  };

  const handleOrderStatusClassSwitch = (status) => {
    switch (status) {
      case "requested":
        return "archieveOrder--requested";
      case "accepted":
        return "archieveOrder--accepted";
      case "fulfilled":
        return "archieveOrder--fulfilled";
      case "cancelled":
        return "archieveOrder--cancelled";
    }
  };

  return (
    <div
      className={`archieveOrder
            ${handleOrderStatusClassSwitch(order.orderStatus)}
        `}
    >
      <div className="archieveOrder__gistContainer">
        <div className="archieveOrder__gistContainer__orderNo">
          Order №{order.orderNo}
        </div>
        <button
          className="archieveOrder__toggleDropdownBtn"
          onClick={() => toggleDropDown()}
        >
          order contents{" "}
          <svg
            className="bi bi-chevron-compact-down"
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M3.553 8.776a.5.5 0 01.67-.223L10 11.44l5.776-2.888a.5.5 0 11.448.894l-6 3a.5.5 0 01-.448 0l-6-3a.5.5 0 01-.223-.67z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div
          className={`archieveOrder__orderbodyContainer ${
            isOrderBodyShown
              ? "archieveOrder__orderbodyContainer--shown"
              : "archieveOrder__orderbodyContainer--hidden"
          }`}
        >
          <div className="orderbodyContainer__tableHead">
            <div className="orderbodyContainer__tableHead__dishName">Item</div>
            <div className="orderbodyContainer__tableHead__dishCounter">
              Amount
            </div>
            <div className="orderbodyContainer__tableHead__dishCost">Sum</div>
          </div>
          {order.orderBody.map((dish, index) => (
            <DishItem dish={dish} index={index} key={dish._id} />
          ))}
          <button
            className="orderbodyContainer__toggleDropdownBtn"
            onClick={() => toggleDropDown()}
          >
            <svg
              className="bi bi-chevron-compact-up"
              width="1em"
              height="1em"
              viewBox="0 0 20 20"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M9.776 7.553a.5.5 0 01.448 0l6 3a.5.5 0 11-.448.894L10 8.56l-5.776 2.888a.5.5 0 11-.448-.894l6-3z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
        <div className="archieveOrder__gistContainer__orderStatus">
          status:{" "}
          {order.orderStatus === "requested"
            ? "requested"
            : order.orderStatus === "accepted"
            ? "accepted"
            : order.orderStatus === "fulfilled"
            ? "fulfilled"
            : "cancelled"}
        </div>
        <div className="archieveOrder__gistContainer__orderTimeFormatted">
          Requested at {order.orderTimeFormatted.slice(0, 5)}{" "}
          {convertDate(order.orderDateFormatted)}
        </div>
        <div className="archieveOrder__gistContainer__orderTakeType">
          Order type:{" "}
          {order.orderTakeType === "eatIn"
            ? "On spot"
            : order.orderTakeType === "takeOut"
            ? "Takeaway"
            : "Delivery"}
        </div>
        <div className="archieveOrder__gistContainer__orderTakeTime">
          Due time: {order.orderTakeTime}
        </div>
        <div className="archieveOrder__gistContainer__orderPaymentType">
          Payment type:{" "}
          {order.orderPaymentType === "onSpot" ? "On spot" : "Online"}
        </div>
        <div className="archieveOrder__gistContainer__orderIsPaid">
          Payment status: {order.orderIsPaid ? "Paid" : "Not paid"}
        </div>
        <div className="archieveOrder__gistContainer__orderSum">
          Order sum: {order.orderSum} $
        </div>
        <button
          disabled={order.active ? true : false}
          className="archieveOrder__gistContainer__deleteOrderBtn"
          onClick={() => setDeleteDivShown(true)}
        >
          <svg
            className="archieveOrder__gistContainer__deleteOrderBtn__svg"
            width="1.8em"
            height="1.8em"
            viewBox="0 0 16 16"
            fill="var(--btn-border-color-red)"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
            />
          </svg>
        </button>
      </div>
      <div
        className={`archieveOrder__confirmDeleteDiv
                    ${
                      isDeleteDivShown
                        ? "archieveOrder__confirmDeleteDiv--shown"
                        : ""
                    }
                `}
      >
        <div
          style={{
            gridArea: "helperDiv",
            textAlign: "center",
            width: "100%",
            marginTop: ".5em",
            marginBottom: ".5em"
          }}
        >
          Delete order from the database?
        </div>
        <button
          className="deleteOrderControlsDiv__cancelBtn"
          onClick={() => setDeleteDivShown(false)}
        >
          Cancel
        </button>
        <button
          className="deleteOrderControlsDiv__deleteOrderBtn"
          onClick={() => handleDeleteOneOrder(order._id)}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default ArchieveOrder;
